import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_MEDIUM_SCREEN_850 } from 'client/constants/mediaQueries';

import './SrBanner.less';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrLink from 'client/components/SrLink/SrLink';
import SrText from 'client/components/SrText';

const SrBanner = ({
  children,
  iconUrl,
  iconHasDropShadow,
  iconDropShadowColor,
  title,
  subtitle,
  backgroundColor,
  onClick,
  to,
  target,
}) => {
  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_850,
  });

  const Container = to ? SrLink : SrBox;

  return (
    <Container to={to} target={target} onClick={onClick}>
      <SrFlex
        styleName="SrBanner"
        onClick={onClick}
        backgroundColor={backgroundColor}
        justify="between"
        align="center"
        padding={isMediumScreen ? '16px' : '17px 32px'}
      >
        {iconUrl && (
          <SrBox display="inlineBlock" marginRight="13px" height="48px">
            <img
              styleName="icon"
              src={iconUrl}
              alt="banner icon"
              height="48px"
              width="auto"
              style={{
                filter: iconHasDropShadow
                  ? `drop-shadow(3px 4px 11px ${iconDropShadowColor})`
                  : null,
              }}
            />
          </SrBox>
        )}
        <SrBox marginRight="50px">
          <SrText
            color="white"
            font="greycliff"
            size={isMediumScreen ? '16' : '21'}
            weight="800"
            lineHeight={isMediumScreen ? '19px' : '25px'}
            letterSpacing="0.5px"
            display="block"
          >
            {title}
          </SrText>
          {subtitle && !isMediumScreen && (
            <SrBox marginTop="3px">
              <SrText
                color="white"
                font="greycliff"
                size="16"
                weight="800"
                lineHeight="19px"
                letterSpacing="0.5px"
                opacity="0.75"
              >
                {subtitle}
              </SrText>
            </SrBox>
          )}
        </SrBox>
        <SrBox marginLeft="auto">
          {isMediumScreen ? (
            <img
              alt="right arrow"
              src="/images/arrow-rounded-small-white.svg"
              width="8px"
              height="14px"
            />
          ) : (
            children
          )}
        </SrBox>
      </SrFlex>
    </Container>
  );
};

SrBanner.propTypes = {
  children: PropTypes.node,
  iconUrl: PropTypes.string,
  iconHasDropShadow: PropTypes.bool,
  iconDropShadowColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  backgroundColor: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string,
  target: PropTypes.string,
};

SrBanner.defaultProps = {
  backgroundColor: '#007AFF',
  target: '_blank',
  iconHasDropShadow: true,
  iconDropShadowColor: '#0067D7',
};

SrBanner.displayName = 'SrBanner';

export default SrBanner;
